var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.avatarImage
    ? _c("img", { class: _vm.classesImg, attrs: { src: _vm.avatarImage } })
    : _c("span", { class: _vm.classesText }, [
        _vm._v("\n    " + _vm._s(_vm.avatarText) + "\n")
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }